import TrainIcon from './TrainIcon';

export default TrainIcon;
